/**
 * Apply the light or dark theme to the page and remember the choice.
 * Tailwind's dark variants and the theme CSS variables key off data-mode="dark";
 * the matching class serves the plain `.dark` selectors.
 *
 * @param {boolean} isDark
 */
export function applyTheme(isDark) {
  const mode = isDark ? 'dark' : 'primary';
  const html = document.documentElement;

  html.setAttribute('data-mode', mode);
  html.classList.remove('dark', 'primary');
  html.classList.add(mode, 'bg-theme-paper');

  localStorage.setItem('darkMode', String(isDark));
}

/**
 * @returns {boolean} Whether the saved preference is dark mode.
 */
export function isSavedThemeDark() {
  return localStorage.getItem('darkMode') === 'true';
}
